import React, { FC } from 'react'
import Button from 'Components/Shared/Button/Button'
import {
  ExperimentEndPageContentStyle,
  ExperimentEndPageStyle,
} from './ExperimentEndPageStyle'
import StoreBanner from '../StoreBanner/StoreBanner'

export interface ExperimentEndPageProps {
  bannerLogoSrc?: string
  bannerName?: string
  onClickReset?: () => void
}

export const ExperimentEndPage: FC<ExperimentEndPageProps> = ({
  bannerName,
  bannerLogoSrc,
  onClickReset,
}) => {
  return (
    <ExperimentEndPageStyle>
      <StoreBanner name={bannerName} logoSrc={bannerLogoSrc} />
      <ExperimentEndPageContentStyle>
        <h1>End of Experiment</h1>
        <div id="content">
          <p>You&apos;ve now reached the end of the experiment.</p>
          <p>
            In a normal experiment, we would record the consumer behaviour
            throughout the interactive experiment for further analysis, this
            includes the time spend per page, the usage of buttons (sort by and
            more information), the product and add-ons (if applicable) selected.
          </p>
          <p>
            Normally a bespoke respondent survey would follow to capture
            opinions about the selected product they selected, likelihood to
            purchase in real-world, and information about the usage/preference
            of their bank account.
          </p>
        </div>
        <Button onClick={onClickReset}>Reset Experiment</Button>
      </ExperimentEndPageContentStyle>
    </ExperimentEndPageStyle>
  )
}
